enum InvitationStatus {
    Pending = 0,
    Refused,
    Accepted,
    Rescheduled,
    RescheduleRefused,
    Canceled
}

export { InvitationStatus }